import z from "zod";
import { DOCUMENT_FILES_TABLES } from "../../../types/documents";

/**
 * The table name is an enum over the registered collections, not a shape test. Thirteen tables in
 * this database end in `Files` and the API serves five of them, so what the validator admits has
 * to be the list itself — a name that merely looks like one of these is a validation error.
 */
export const getDocumentsFilesTableSchema = z.object({
	documentFilesTable: z.enum(DOCUMENT_FILES_TABLES),
	identifier: z.string().min(1),
});

/**
 * `additionalFields` is a JSON object of column/value pairs the collection is filtered by on read
 * and stamped with on upload — the worksite documents use it for the worksite and the document
 * type. The keys are checked against the registered table's own columns in the handler, because
 * only there is the table known.
 */
export const getDocumentsQuerySchema = z.object({
	additionalFields: z.string().optional(),
});

export type GetDocumentsFilesTableParams = z.infer<typeof getDocumentsFilesTableSchema>;
export type GetDocumentsQueryParams = z.infer<typeof getDocumentsQuerySchema>;
